module.exports = __webpack_public_path__ + "static/media/mulher_r1_c6.f534c468.jpg";